import React from 'react';
import PaymentOptions, {
  PaymentOptionsColumn,
  PaymentOptionIcon,
  PaymentOptionImages,
  PaymentOptionButtons,
  PaymentOptionNote,
  PaymentOptionList
} from '../../../components/PaymentOptions/PaymentOptions';
import { Link } from '@latitude/link';
import Section from '@latitude/section-rebrand';
import SvgInline from '@latitude/svg-inline';
import { PADDING, MARGIN, REBRAND_COLOR } from '@latitude/core/utils/constants';
import { Typography } from '@latitude/typography';
import Button from '@latitude/button-rebrand';

const PaymentOption = () => {
  return (
    <Section
      id="payment-options"
      css={`
        background-color: ${REBRAND_COLOR.WHITE};
        padding-top: ${PADDING.P32};
        padding-bottom: ${PADDING.P32};
        div.payment-options-tabs__item {
          justify-content: space-evenly;
        }
        div.accordion__item > button {
          background-color: ${REBRAND_COLOR.MID_BLUE_10} !important;
        }
        li {
          padding: 13px 0 !important;
        }
      `}
    >
      <Typography.H4
        css={`
          margin-bottom: ${MARGIN.M32} !important;
        `}
      >
        Payment Options
      </Typography.H4>
      <PaymentOptions
        data={[
          {
            id: 'latitude-app',
            title: '',
            titleRebrand: 'Latitude App',
            titleHtml: 'Latitude App',
            content: (
              <React.Fragment>
                <PaymentOptionsColumn
                  css={`
                    gap: 16px;
                    display: flex;
                    flex-direction: column;
                  `}
                >
                  <PaymentOptionIcon
                    css={`
                      justify-content: flex-start;
                      width: 72px;
                      height: 72px;
                      margin: 0;
                      svg {
                        width: 100%;
                        height: 100%;
                      }
                    `}
                  >
                    <SvgInline name="icon-device-mobile-rebrand" />
                  </PaymentOptionIcon>
                  <Typography.SH4 semibold>Latitude App</Typography.SH4>
                  <Typography.Body color={REBRAND_COLOR.INDIGO}>
                    Make repayments in just a few taps with our mobile app.
                  </Typography.Body>
                  <PaymentOptionImages>
                    <Link
                      href="https://itunes.apple.com/app/apple-store/id1373059866?pt=118165058&ct=InfPayOpt0319&mt=8"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-inline"
                      data-trackid="payment-options-itunes-app-link"
                      trackEventData={{
                        label: 'app-store',
                        location: 'payment-options'
                      }}
                    >
                      <img
                        src={
                          require('../../../images/badge-app-store.svg').default
                        }
                        height="48px"
                        alt="app store"
                      />
                    </Link>
                    <Link
                      href="https://play.google.com/store/apps/details?id=com.latitudefinancial.latitudeapp&referrer=utm_source%3DInfPayOpt0319"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-inline"
                      data-trackid="payment-options-googleplay-app-link"
                      trackEventData={{
                        label: 'play-store',
                        location: 'payment-options'
                      }}
                    >
                      <img
                        src={
                          require('../../../images/badge-google-play.svg')
                            .default
                        }
                        height="48px"
                        alt="play store"
                      />
                    </Link>
                  </PaymentOptionImages>
                </PaymentOptionsColumn>
                <PaymentOptionsColumn>
                  <PaymentOptionList
                    css={`
                      gap: 10px;
                      display: flex;
                      flex-direction: column;
                      padding: 0;
                    `}
                  >
                    <Typography.Body small>1. Get the app</Typography.Body>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      Simply download the Latitude App from the App Store or
                      Google Play
                    </Typography.Body>

                    <Typography.Body small>
                      2. Create a Latitude ID
                    </Typography.Body>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      Open the app and create your Latitude ID (this is
                      different to your Latitude Service Centre login).
                    </Typography.Body>

                    <Typography.Body small>3. Link your card</Typography.Body>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      Once your credit cards are linked, you’ll be able to make
                      payments via bank transfer with your BSB and Account
                      Number (Australia only).
                    </Typography.Body>
                  </PaymentOptionList>
                </PaymentOptionsColumn>
                <PaymentOptionsColumn
                  css={`
                    gap: 20px;
                    display: flex;
                    flex-direction: column;
                  `}
                >
                  <PaymentOptionNote>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      <b>Note: </b>Please be aware that bank transfer payments
                      can take three business days to clear and you can only
                      make one payment to your card account every five days.
                    </Typography.Body>
                  </PaymentOptionNote>
                  <PaymentOptionNote>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      <b>No Fees </b>
                    </Typography.Body>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      We do not charge a fee for payments made via direct bank
                      transfer on the Latitude App.
                    </Typography.Body>
                  </PaymentOptionNote>
                </PaymentOptionsColumn>
              </React.Fragment>
            )
          },
          {
            id: 'online-service-centre',
            title: '',
            titleRebrand: 'Latitude Service Centre',
            titleHtml: 'Latitude Service Centre',
            content: (
              <React.Fragment>
                <PaymentOptionsColumn
                  css={`
                    gap: 16px;
                    display: flex;
                    flex-direction: column;
                  `}
                >
                  <PaymentOptionIcon
                    css={`
                      justify-content: flex-start;
                      width: 72px;
                      height: 72px;
                      margin: 0;
                      svg {
                        width: 100%;
                        height: 100%;
                      }
                    `}
                  >
                    <SvgInline name="icon-globe-simple-rebrand" />
                  </PaymentOptionIcon>
                  <Typography.SH4 semibold>
                    Latitude Service Centre
                  </Typography.SH4>
                  <Typography.Body color={REBRAND_COLOR.INDIGO}>
                    One of the quickest &amp; easiest way to make repayments.
                  </Typography.Body>
                  <PaymentOptionButtons css="justify-content:center; gap: 8px;a {margin: 0}">
                    <Button
                      variant="secondary-blue"
                      size="md"
                      target="_blank"
                      ctaText="Login"
                      ctaUrl="https://servicecentre.latitudefinancial.com.au/login"
                      data-trackid="payment-options-service-center-login-link"
                      css="margin: 0 8px; flex: 1 1 50%;"
                      disableDefaultEventTracking
                    />

                    <Button
                      target="_blank"
                      variant="secondary-blue"
                      size="md"
                      ctaText="Register"
                      ctaUrl="https://servicecentre.latitudefinancial.com.au/register"
                      data-trackid="payment-options-service-center-register-link"
                      css="margin: 0 8px; flex: 1 1 50%;"
                      disableDefaultEventTracking
                    />
                  </PaymentOptionButtons>
                </PaymentOptionsColumn>
                <PaymentOptionsColumn>
                  <Typography.SH4 semibold>To make a payment</Typography.SH4>
                  <PaymentOptionList
                    css={`
                      gap: 10px;
                      display: flex;
                      flex-direction: column;
                      padding: 0;
                    `}
                  >
                    <Typography.Body small>
                      1. Login to the Latitude Service Centre
                    </Typography.Body>

                    <Typography.Body small>
                      2. Click ‘Pay My Account’
                      <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                        Then enter your bank details.
                      </Typography.Body>
                    </Typography.Body>
                  </PaymentOptionList>
                  <Typography.SH4 semibold>Registering</Typography.SH4>
                  <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                    Registering is easy and only takes a few minutes, just make
                    sure you have your card or 16-digit account number on hand.
                  </Typography.Body>
                </PaymentOptionsColumn>
                <PaymentOptionsColumn
                  css={`
                    gap: 20px;
                    display: flex;
                    flex-direction: column;
                  `}
                >
                  <PaymentOptionNote>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      <b>Note: </b>Please be aware that payments can take 3 to 5
                      business days to clear.
                    </Typography.Body>
                  </PaymentOptionNote>

                  <PaymentOptionNote>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      <b>No Fees </b>{' '}
                    </Typography.Body>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      We do not charge a fee for payments made via the Latitude
                      Service Centre.
                    </Typography.Body>
                  </PaymentOptionNote>
                </PaymentOptionsColumn>
              </React.Fragment>
            )
          },
          {
            id: 'bpay',
            title: '',
            titleRebrand: 'BPAY',
            titleHtml:
              'BPAY<sup style="font-size: 0.75em; top: -0.5em;">&reg;</sup>',
            content: (
              <React.Fragment>
                <PaymentOptionsColumn
                  css={`
                    gap: 16px;
                    display: flex;
                    flex-direction: column;
                  `}
                >
                  <PaymentOptionIcon
                    css={`
                      justify-content: flex-start;
                      width: 70px;
                      height: 31px;
                      margin: 0;
                      svg {
                        width: 100%;
                        height: 100%;
                      }
                    `}
                  >
                    <SvgInline name="icon-bpay-rebrand" />
                  </PaymentOptionIcon>
                  <Typography.SH4 semibold>
                    BPAY<sup>®</sup>
                  </Typography.SH4>
                  <Typography.Body color={REBRAND_COLOR.INDIGO}>
                    Available 24 hours a day, seven days a week.
                  </Typography.Body>
                </PaymentOptionsColumn>
                <PaymentOptionsColumn>
                  <Typography.SH4 semibold>To make a payment</Typography.SH4>
                  <PaymentOptionList
                    css={`
                      gap: 10px;
                      display: flex;
                      flex-direction: column;
                      padding: 0;
                    `}
                  >
                    <Typography.Body small>
                      1. Quote the Biller code
                      <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                        Latitude 28° Global Platinum Mastercard Biller Code
                        (150615)
                      </Typography.Body>
                    </Typography.Body>

                    <Typography.Body small>
                      2. Your account number
                    </Typography.Body>

                    <Typography.Body small>
                      3. The amount you wish to pay
                    </Typography.Body>
                  </PaymentOptionList>
                </PaymentOptionsColumn>
                <PaymentOptionsColumn
                  css={`
                    gap: 20px;
                    display: flex;
                    flex-direction: column;
                  `}
                >
                  <PaymentOptionNote>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      <b>Note: </b> If you’re paying by BPAY on your due date,
                      you must complete the transaction before your bank’s cut
                      off time, otherwise the transaction may be processed on
                      the following day. Some BPAY payments can take up to three
                      days to appear on your account.
                    </Typography.Body>
                  </PaymentOptionNote>
                  <PaymentOptionNote>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      <b>Fees </b>{' '}
                    </Typography.Body>
                    <Typography.Body small color={REBRAND_COLOR.INDIGO}>
                      A payment handling fee of $1.95 applies for all payments
                      made via BPAY<sup>&reg;</sup> to pay your account.
                    </Typography.Body>
                  </PaymentOptionNote>
                </PaymentOptionsColumn>
              </React.Fragment>
            )
          },
          {
            id: 'direct-debit',
            title: '',
            titleRebrand: 'Direct Debit',
            titleHtml: 'Direct Debit',
            content: (
              <>
                <PaymentOptionsColumn
                  css={`
                    gap: 16px;
                    display: flex;
                    flex-direction: column;
                  `}
                >
                  <PaymentOptionIcon
                    css={`
                      justify-content: flex-start;
                      width: 72px;
                      height: 72px;
                      margin: 0;
                      svg {
                        width: 100%;
                        height: 100%;
                      }
                    `}
                  >
                    <SvgInline name="icon-calender-rebrand" />
                  </PaymentOptionIcon>
                  <Typography.SH4 semibold>Direct Debit</Typography.SH4>
                  <Typography.Body color={REBRAND_COLOR.INDIGO}>
                    Easily make recurring repayments.
                  </Typography.Body>
                </PaymentOptionsColumn>
                <PaymentOptionsColumn longColumn>
                  <Typography.Body color={REBRAND_COLOR.INDIGO}>
                    The easiest (and quickest) way to pay off your credit card
                    is with a <strong> monthly direct debit</strong>.
                  </Typography.Body>
                  <br />
                  <Typography.Body color={REBRAND_COLOR.INDIGO}>
                    You can choose whether to pay a set amount, the monthly
                    minimum or the full closing balance, and on your due date
                    each month your payment will automatically happen!
                  </Typography.Body>
                  <br />
                  <Typography.LinkRegular href="https://latitudefs.zendesk.com/hc/en-au/articles/6027991389329-Direct-Debit-Cards">
                    Click here to find out more about setting up a direct debit.
                  </Typography.LinkRegular>
                </PaymentOptionsColumn>
              </>
            )
          }
        ]}
        // tabContentMinHeight="385px"
        css={`
          && {
            .payment-options-tabs__content {
              padding: 32px;
            }
          }
        `}
      />
    </Section>
  );
};

export default PaymentOption;
